import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import ConfirmDialog from '../../components/ConfirmDialog';
import { deleteSubscription } from '../../source/subscriptions';
import { remove } from '../queryKeyFactory';

export const useDeleteSubscription = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const removeMutation = useMutation(remove(), deleteSubscription, {
    successMessage: () => `Subscription deleted`,
    refresh: true,
  });

  const handleAction = async (item) => {
    await showModal({
      title: `Delete subscription?`,
      confirmActionLabel: 'Delete',
    });
    await removeMutation.mutateAsync({ id: item.id });
  };

  return [handleAction, removeMutation];
};
